document.addEventListener("DOMContentLoaded", () => {
    window.addEventListener("scroll", () => {
        document.querySelector('#input-search').classList.add('d-none');

        const goToTopButton = document.querySelector('.js-gototop');
        if (goToTopButton) {
            if (window.scrollY > 150) {
                goToTopButton.classList.remove('d-none');
            } else {
                goToTopButton.classList.add('d-none');
            }
        }
    });

     /*
         * SEARCH
         * */
     if (document.querySelectorAll('.js-open-search').length > 0) {
        let searchLinks = document.querySelectorAll('.js-open-search');
        for (const searchLink of searchLinks) {
            if (!searchLink.dataset.input) {
                // console.error("data-input attribute is missing on: ", searchLink);
                continue;
            }

            searchLink.addEventListener('click', function (e) {
                e.preventDefault();
                const inputSelector = searchLink.dataset.input;
                const inputElement = document.querySelector(inputSelector);

                if (!inputElement) {
                    // console.error("Element not found for selector: ", inputSelector);
                    return;
                }

                const focusElement = inputElement.querySelector('input[name="q"]');

                if ((window.innerWidth + 15) < 1400) {
                    if (searchLink.classList.contains("js-is-active")) {
                        inputElement.classList.add('d-none');
                        document.querySelector('header').classList.remove('menu-open');
                        for (const searchLink2 of searchLinks) {
                            searchLink2.classList.remove('js-is-active');
                        }
                    } else {
                        inputElement.classList.remove('d-none');
                        if (focusElement) {
                            focusElement.focus();
                        }
                        document.querySelector('header').classList.add('menu-open');
                        // Ensure drawer and navButton are defined
                        if (typeof drawer !== 'undefined' && typeof navButton !== 'undefined') {
                            drawer.close();
                            navButton.classList.remove('js-is-active');
                        }
                        for (const searchLink2 of searchLinks) {
                            searchLink2.classList.add('js-is-active');
                        }
                    }
                } else {
                    if (searchLink.classList.contains("js-is-active")) {
                        for (const searchLink2 of searchLinks) {
                            searchLink2.classList.remove('js-is-active');
                        }
                        inputElement.classList.add('d-none');
                    } else {
                        for (const searchLink2 of searchLinks) {
                            searchLink2.classList.add('js-is-active');
                        }
                        if (typeof drawer !== 'undefined' && typeof navButton !== 'undefined') {
                            drawer.close();
                            navButton.classList.remove('js-is-active');
                        }
                        inputElement.classList.remove('d-none');
                        if (focusElement) {
                            focusElement.focus();
                        }
                    }
                }
            });
        }
    }
});

